import React, { useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import CardOncologia from "_+_Portal/components/Turnos/CardOncologia/CardOncologia";
import "./Oncología.css";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const Oncologia = () => {
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  return (
    <React.Fragment>
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Oncología"} />
      <div className="ptur-bodyContainer-oncologia">
        <Sidebar />
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-oncologia-container"}
        >
          <div className="ptur-oncologia-caja1">
            <CardOncologia />
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default Oncologia;
